// Marks painted on the squares *under* the pieces: last-move tint, the
// selected square, and the red glow under a king in check.
import { SQUARE_SIZE } from '../../utils/constants.js';
import { squareToCanvasCenter, squareToCanvasRect, type ViewerRotation } from '../geometry.js';
import type { RenderPalette } from '../palette.js';
import type { Square } from '../../game/types.js';

export interface BoardMarks {
  readonly lastMove: { readonly from: Square; readonly to: Square } | null;
  readonly selected: Square | null;
  /** The king square of the side to move when it is in check. */
  readonly checkSquare: Square | null;
}

function tint(ctx: CanvasRenderingContext2D, sq: Square, color: string, rotation: ViewerRotation): void {
  const r = squareToCanvasRect(sq, rotation);
  ctx.fillStyle = color;
  ctx.fillRect(r.x, r.y, r.w, r.h);
}

export function drawSquareMarks(
  ctx: CanvasRenderingContext2D,
  marks: BoardMarks,
  palette: RenderPalette,
  rotation: ViewerRotation,
): void {
  ctx.save();
  if (marks.lastMove !== null) {
    tint(ctx, marks.lastMove.from, palette.lastMoveTint, rotation);
    tint(ctx, marks.lastMove.to, palette.lastMoveTint, rotation);
  }
  if (marks.selected !== null) tint(ctx, marks.selected, palette.lastMoveTint, rotation);
  if (marks.checkSquare !== null) {
    const { x, y } = squareToCanvasCenter(marks.checkSquare, rotation);
    const glow = ctx.createRadialGradient(x, y, 0, x, y, SQUARE_SIZE * 0.6);
    glow.addColorStop(0, palette.checkGlow);
    glow.addColorStop(0.55, 'rgba(230, 40, 30, 0.35)');
    glow.addColorStop(1, 'rgba(230, 40, 30, 0)');
    const r = squareToCanvasRect(marks.checkSquare, rotation);
    ctx.fillStyle = glow;
    ctx.fillRect(r.x, r.y, r.w, r.h);
  }
  ctx.restore();
}
